import { isNullOrUndefined } from '@as-react/common-utils';
import { NAVIGATION_HORIZONTAL, NAVIGATION_HORIZONTAL_COLLAPSE } from '../constants/DOMElementsConstants';
export const TAG_NAMES = {
    BASE: 'base',
    BODY: 'body',
    HEAD: 'head',
    HTML: 'html',
    LINK: 'link',
    META: 'meta',
    NOSCRIPT: 'noscript',
    SCRIPT: 'script',
    STYLE: 'style',
    TITLE: 'title',
};
const findOrCreateElementInDomElement = (parentElement, elementSelector, elementTag, attributes) => {
    let domElement = parentElement.querySelector(elementSelector);
    if (isNullOrUndefined(domElement)) {
        domElement = document.createElement(elementTag);
        parentElement.appendChild(domElement);
    }
    Object.keys(attributes).forEach(_key => {
        domElement.setAttribute(_key, attributes[_key]);
    });
    return domElement;
};
export const findOrCreateElementInBody = (elementSelector, elementTag, attributes) => {
    const bodyElement = document.body || document.querySelector(TAG_NAMES.BODY);
    return findOrCreateElementInDomElement(bodyElement, elementSelector, elementTag, attributes);
};
export const findOrCreateElementInHead = (elementSelector, elementTag, attributes) => {
    const headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    return findOrCreateElementInDomElement(headElement, elementSelector, elementTag, attributes);
};
export const showMobileHeader = () => {
    var _a, _b;
    if ((_a = document.querySelector(NAVIGATION_HORIZONTAL)) === null || _a === void 0 ? void 0 : _a.classList.contains(NAVIGATION_HORIZONTAL_COLLAPSE)) {
        (_b = document.querySelector(NAVIGATION_HORIZONTAL)) === null || _b === void 0 ? void 0 : _b.classList.remove(NAVIGATION_HORIZONTAL_COLLAPSE);
    }
};
export const findParents = (el, selector) => {
    const parentNodes = [];
    if (!selector) {
        return parentNodes;
    }
    while ((el = el.parentNode) && el !== document) {
        if (!selector || el.matches(selector)) {
            parentNodes.unshift(el);
        }
    }
    return parentNodes;
};
